<template>
  <v-list-item @click="copyItemListToClipboard">
    <v-list-item-icon class="mr-2">
      <v-icon>mdi-clipboard-arrow-down-outline</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>テキストコピー</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({ activeItems: 'PostEditor/activeItems' })
  },
  methods: {
    getTextContent (itemContent) {
      let regexResults = itemContent.match(/<p>(.*?)<\/p>/g)
      let resultContent = ''
      regexResults.forEach((result) => {
        resultContent += `${result.replace(/<[^>]*>?/gm, '')}\n`
      })
      return resultContent
    },
    copyItemListToClipboard: async function () {
      if (!navigator.clipboard) {
        const payload = {
          status: 500,
          message:
            'clipboardAPIを利用するために、https環境で実行してください。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      var copyTexts = ''
      this.activeItems.forEach((item) => {
        switch (item.variety) {
          case 'heading':
            copyTexts += `${item.itemableAttributes.content}\n`
            break
          case 'text':
            if (/<p>(.*?)<\/p>/.test(item.itemableAttributes.content)) {
              copyTexts += this.getTextContent(item.itemableAttributes.content)
            } else {
              copyTexts += `${item.itemableAttributes.content}\n`
            }
            break
          case 'table_item':
            copyTexts += `${item.itemableAttributes.tableTitle}\n`
            Object.keys(item.itemableAttributes.tableContent).forEach(
              (key) =>
                (copyTexts += `${item.itemableAttributes.tableContent[key]}\n`)
            )
            break
        }
      })
      await navigator.clipboard.writeText(copyTexts).then(
        () => {
          const payload = {
            status: 200,
            message: '保存済み記事の内容をクリップボードにコピーしました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: 500,
            message: `コピーできませんでした(${error})`
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
